<script setup lang="ts">
import { computed } from "vue";

import { useRoute } from "vue-router";
import { useGetProject } from "@/stores/queries";

const route = useRoute();

const projectId = computed(() => {
  return route.params.id ? Number(route.params.id) : undefined;
});

const { data: project } = useGetProject(projectId);
</script>

<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item
      :to="{
        name: 'projects',
      }"
      >{{ $t("dashboard:navigation.projects") }}</el-breadcrumb-item
    >
    <el-breadcrumb-item v-if="project">{{ project.name }}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<style lang="scss" scoped></style>
